module.exports = __webpack_public_path__ + "static/media/instagram-icon-logo-loading.e195cbde.e195cbde.svg";